/*
 Copyright 2018 Google Inc. All Rights Reserved.
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/

import Event from './shims/Event.mjs';

/**
 * implements {IStateChangeEvent}
 */
export default class StateChangeEvent extends Event {
  /**
   * @param {string} type
   * @param {!Object} initDict
   */
  constructor(type, initDict) {
    super(type);
    this.newState = initDict.newState;
    this.oldState = initDict.oldState;
    this.originalEvent = initDict.originalEvent;
  }
}
